import { Input, Directive } from '@angular/core';
import { IBaseVraagboomResultaat, VraagboomAntwoord } from '@models/vragenboom';
import { BaseOlsControlDirective } from '../../base/base-ols-control';

@Directive()
export abstract class BaseSummaryControlDirective<TResultaat extends IBaseVraagboomResultaat> extends BaseOlsControlDirective {
  @Input() antwoordResultaat: VraagboomAntwoord<TResultaat>;
}
